// useFormActions.js
import { ref } from 'vue';

export function useFormActions() {
    const isEditing = ref(false);
    const isAddForm = ref(false);

    const startEdit = () => {
        isEditing.value = true;
    };

    const saveChanges = (contact) => {
        // Logic to save the new contact
        console.log('Saving new contact:', contact);
        isEditing.value = false;
    };

    const updateItem = (contact) => {
        // Logic to update an existing contact
        console.log('Updating contact:', contact);
        isEditing.value = false;
    };

    const triggerDelete = () => {
        // Logic to delete the contact
        console.log('Deleting contact');
    };

    const initializeForm = (isAdd) => {
        isAddForm.value = isAdd;
        isEditing.value = isAdd; // Automatically start in editing mode if adding a new item
    };

    return {
        isEditing,
        isAddForm,
        startEdit,
        saveChanges,
        updateItem,
        triggerDelete,
        initializeForm,
    };
}
